import i18n from "i18n";

// Affichage traduit des valeurs stockées en base sous forme de libellés français.
// La valeur en DB ne change jamais : seule l'étiquette affichée passe par i18n.

const LANGUES = {
  Français: "francais",
  Arabe: "arabe",
  Anglais: "anglais",
  Turc: "turc",
  Berbère: "berbere",
  Autre: "autre",
};

const SCOLARITE = {
  Collège: "college",
  Lycée: "lycee",
  Supérieur: "superieur",
  "6ème": "6e",
  "5ème": "5e",
  "4ème": "4e",
  "3ème": "3e",
  "2nde": "2nde",
  "1ère": "1re",
  Terminale: "terminale",
  "Étudiant(e)": "etudiant",
  "Diplômé(e)": "diplome",
};

const traduire = (groupe, cle, brut) =>
  cle ? i18n.t(`valeurs.${groupe}.${cle}`, { defaultValue: brut }) : brut;

// "Français" → "الفرنسية" ; une langue libre ("Wolof") reste telle quelle
export const libelleLangue = (v) => traduire("langues", LANGUES[v], v);

// "6ème" / "Étudiant(e)" / "Collège" (groupe)
export const libelleScolarite = (v) => traduire("scolarite", SCOLARITE[v], v);

// "lundi" (cours.jours_semaine) ou "Lundi" (eleve.disponibilites)
export const libelleJour = (v, court = false) =>
  v ? traduire(court ? "joursCourts" : "jours", String(v).toLowerCase(), v) : v;

// Codes quoran / arabe / science
export const libelleMatiere = (code, court = false) =>
  code ? traduire(court ? "matiereCourt" : "matiere", code, code) : code;

// Groupes simples à codes : sexe, situation, niveau, mode, typeCours, typeGroupe,
// statutSuivi, resultatExamen, statutReunion, statutPresence, engagement
export const libelleValeur = (groupe, code) =>
  code === null || code === undefined || code === "" ? "" : traduire(groupe, String(code), String(code));
